/* Register the PWA service worker and expose the 'install app' prompt. */

export function registerPwa() {
  if (typeof window === "undefined") return;
  if (!("serviceWorker" in navigator)) return;
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js", { scope: "/" })
      .then(() => {
        // ready
      })
      .catch((err) => {
        console.warn("[PWA] SW registration failed:", err);
      });
  });
}

/** Capture install prompt event and expose an installer function. */
let deferredPrompt = null;
const listeners = new Set();

if (typeof window !== "undefined") {
  window.addEventListener("beforeinstallprompt", (e) => {
    e.preventDefault();
    deferredPrompt = e;
    listeners.forEach((cb) => cb(true));
  });
  window.addEventListener("appinstalled", () => {
    deferredPrompt = null;
    listeners.forEach((cb) => cb(false));
  });
}

export function canInstall() {
  return !!deferredPrompt;
}

export function onInstallChange(cb) {
  listeners.add(cb);
  return () => listeners.delete(cb);
}

export async function promptInstall() {
  if (!deferredPrompt) return { outcome: "not-available" };
  deferredPrompt.prompt();
  const res = await deferredPrompt.userChoice;
  deferredPrompt = null;
  listeners.forEach((cb) => cb(false));
  return res;
}

export function isStandalone() {
  if (typeof window === "undefined") return false;
  const mq = window.matchMedia?.("(display-mode: standalone)")?.matches;
  const iosStandalone = "standalone" in window.navigator && window.navigator.standalone;
  return Boolean(mq || iosStandalone);
}
